import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Wallet, Ruler } from "lucide-react";
import { SampleTag } from "@/components/AuctionCard";

export function BrandLogo({ brand, size = "w-14 h-14", text = "text-lg" }) {
    if (brand.logo) {
        return <img src={brand.logo} alt={`${brand.name} logo`} className={`${size} object-contain bg-white border border-black/10 p-1.5`}/>;
    }
    const initials = (brand.name || "?").split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();
    return (
        <span className={`${size} ${text} bg-[#0a0d18] text-[var(--ebg-gold)] border border-[var(--ebg-gold)]/40 font-serif flex items-center justify-center shrink-0`}>
            {initials}
        </span>
    );
}

export default function BrandCard({ brand }) {
    return (
        <Link
            to={`/brands/${brand.slug}`}
            data-testid={`brand-card-${brand.slug}`}
            className="group block bg-white border border-black/8 hover:shadow-[0_18px_40px_-20px_rgba(0,0,0,0.35)] transition-shadow duration-500"
        >
            <div className="relative aspect-[16/10] overflow-hidden bg-black/5">
                {brand.cover_image && <img src={brand.cover_image} alt={brand.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"/>}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"/>
                <div className="absolute top-4 left-4 flex gap-2">
                    <span className="bg-[var(--ebg-gold)] text-black px-2.5 py-1 text-[10px] uppercase tracking-[0.2em] font-bold">{brand.opportunity_type}</span>
                    <SampleTag show={brand.is_sample}/>
                </div>
                <div className="absolute bottom-4 left-4 right-4 flex items-end gap-3">
                    <BrandLogo brand={brand}/>
                    <div className="min-w-0 text-white">
                        <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-[var(--ebg-gold)]">{brand.category}</div>
                        <h3 className="font-serif text-[22px] leading-tight truncate">{brand.name}</h3>
                    </div>
                </div>
            </div>
            <div className="p-5">
                {brand.tagline && <p className="text-black/60 text-sm leading-relaxed line-clamp-2 min-h-[2.5rem]">{brand.tagline}</p>}
                <div className="mt-4 grid grid-cols-2 gap-3 text-[12px]">
                    <div className="flex items-start gap-2"><Wallet size={13} className="text-[var(--ebg-gold)] mt-0.5 shrink-0"/><div><div className="text-black/45 text-[10px] uppercase tracking-[0.16em]">Investment</div><div className="font-bold">{brand.investment_range || "On request"}</div></div></div>
                    <div className="flex items-start gap-2"><Ruler size={13} className="text-[var(--ebg-gold)] mt-0.5 shrink-0"/><div><div className="text-black/45 text-[10px] uppercase tracking-[0.16em]">Space</div><div className="font-bold">{brand.area_required || "Flexible"}</div></div></div>
                </div>
                <div className="mt-4 pt-4 border-t border-black/8 flex justify-end">
                    <span className="text-[10px] uppercase tracking-[0.2em] font-bold text-[var(--ebg-gold)] border border-[var(--ebg-gold)]/50 px-3 py-2 group-hover:bg-[var(--ebg-gold)] group-hover:text-black transition-colors inline-flex items-center gap-1.5">
                        View Opportunity <ArrowRight size={11}/>
                    </span>
                </div>
            </div>
        </Link>
    );
}
